import { ThemeEvents } from '@theme/events';

class BymsPdpShipping extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section') ?? document;
    this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    this.scope.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  handleVariantUpdate(event) {
    const variantId = event.detail?.resource?.id;
    if (!variantId) return;

    const variantState = this.querySelector(
      `template[data-shipping-variant="${CSS.escape(String(variantId))}"]`,
    );
    const message = this.querySelector('[data-shipping-message]');
    const track = this.querySelector('[data-shipping-track]');
    const fill = this.querySelector('[data-shipping-fill]');

    if (!variantState || !message || !track || !fill) return;

    const progress = Math.min(100, Math.max(0, Number(variantState.dataset.progress) || 0));
    const reached = variantState.dataset.reached === 'true';

    message.textContent = variantState.content.textContent.trim();
    track.setAttribute('aria-valuenow', String(progress));
    fill.style.setProperty('--shipping-progress', `${progress}%`);
    this.classList.toggle('byms-pdp-shipping--reached', reached);
  }
}

if (!customElements.get('byms-pdp-shipping')) {
  customElements.define('byms-pdp-shipping', BymsPdpShipping);
}
